"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitAndRunMode = exports.HitAndRunStrategy = void 0;
// Hit and Run reuses the same strategies as Sidestep
// The UI is a toggle + select in the block action dialog
var sidestep_1 = require("./sidestep");
Object.defineProperty(exports, "HitAndRunStrategy", { enumerable: true, get: function () { return sidestep_1.SidestepStrategy; } });
var HitAndRunMode;
(function (HitAndRunMode) {
    HitAndRunMode["DISABLED"] = "DISABLED";
    HitAndRunMode["ENABLED"] = "ENABLED";
})(HitAndRunMode || (exports.HitAndRunMode = HitAndRunMode = {}));
